import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import AdminPage from "../../components/AdminPage";
import TableComponent from "../../components/adminTableComponent";
import { LoaderWrapper } from "../../components/LoaderWrapper";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import { SpecificView } from "../../components/SpecificView/SpecificView";
import { loadIndustriesTypes } from "../IndustryTypes/loadData";
import { AddMajor } from "./addModal";
import { loadMajors } from "./loadData";
import { MajorHeaders } from "./tableHeaders";

const Majors = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [majors, setMajors] = useState([]);
  const [opened, setOpened] = useState(false);
  const [update, setUpdate] = useState(false);
  const [viewModalState, setViewModalState] = useState(false);
  const [viewModalData, setViewModalData] = useState({});

  useEffect(() => {
    loadMajors(setLoading).then(setMajors);
  }, [location.pathname, update]);

  const [allIndustryTypes, setAllIndustryTypes] = useState([]);
  useEffect(() => {
    loadIndustriesTypes(setLoading).then(setAllIndustryTypes);
  }, [location.pathname]);

  return (
    <AdminPage title="Majors">
      <ModalWrapper
        opened={viewModalState}
        setOpened={setViewModalState}
        title={"Major's Details"}
        InternalComponent={
          <SpecificView
            name={viewModalData?.majorName}
            description={viewModalData?.majorDescription}
            date={viewModalData?.createdDate}
            status={viewModalData?.state}
          />
        }
      />
      {allIndustryTypes.length > 0 && (
        <AddMajor
          opened={opened}
          setOpened={setOpened}
          allIndustryTypes={allIndustryTypes}
          setUpdate={setUpdate}
        />
      )}
      <LoaderWrapper loading={loading}>
        <TableComponent
          headCells={MajorHeaders}
          rowData={majors}
          setViewModalData={setViewModalData}
          setViewModalState={setViewModalState}
          opened={opened}
          setOpened={setOpened}
          showAddButton={true}
        />
      </LoaderWrapper>
    </AdminPage>
  );
};

export default withTranslation()(Majors);
